import React, { useState, useEffect, useContext } from "react";
import "./News.scss";
import NewsTable from "./NewsTable";
import { FixedHeader, PrimaryHeader } from "../../ui/Header";
import Select from "../../ui/Select/Select";
import Button from "../../ui/Button/Button";
import DateRange from "../../ui/DateRange/DateRange";
import useSearch from "../../hooks/useSearch";
import { teaserStatus } from "../../constants";
import GlobalsContext from "../../context/GlobalsContext";
import { BulkStatusChangeById, NewsStatService } from "../../utils/api";
import moment from "moment";

const actionOptions = [
  { label: "Запустить", value: teaserStatus.active },
  { label: "Остановить", value: teaserStatus.inactive },
  { label: "Отклонить", value: teaserStatus.reject }
];

const statusOptions = [
  { label: "Активные", value: teaserStatus.active },
  { label: "Неактивные", value: teaserStatus.inactive },
  { label: "Отклоненные", value: teaserStatus.reject }
];

const News = ({ location, history }) => {
  const globalsContext = useContext(GlobalsContext);
  const [action, setAction] = useState("");
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [stat, setStat] = useState({
    stat: [],
    summary: {}
  });

  const [checked, setChecked] = useState([]);

  const [search, setSearch] = useSearch(
    {
      cid: "",
      status: "",

      d1start: moment().format("YYYY-MM-DD"),
      d1end: moment().format("YYYY-MM-DD"),

      d2start: moment().subtract(30, "days").format("YYYY-MM-DD"),
      d2end: moment().format("YYYY-MM-DD")
    },
    location,
    history
  );

  // callbacks
  const onCheck = ({ id, checked }) => {
    if (checked) {
      setChecked(prev => [...prev, id]);
    } else {
      setChecked(prev => prev.filter(itemId => itemId != id));
    }
  };

  const onGlobalCheck = ({ checked }) => {
    if (checked) {
      setChecked(stat.stat.map(item => item.tid));
    } else {
      setChecked([]);
    }
  };

  const onActionSelect = item => {
    setAction(item.value);
  };

  const onStatusSelect = item => {
    setSearch({ status: item.value });
  };

  const onCampaignSelect = item => {
    setSearch({ cid: item.value });
  };

  const applyAction = () => {
    setActionLoading(true);

    BulkStatusChangeById({ status: action, teaser_ids: checked })
      .then(data => {
        setActionLoading(false);
        setChecked([]);
        setAction("");
        load();
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        setActionLoading(false);
      });
  };

  const onD1Change = ({ startDate: d1start, endDate: d1end }) => {
    setSearch({
      d1start: moment(d1start).format("YYYY-MM-DD"),
      d1end: moment(d1end).format("YYYY-MM-DD")
    });
  };

  const onD2Change = ({ startDate: d2start, endDate: d2end }) => {
    setSearch({
      d2start: moment(d2start).format("YYYY-MM-DD"),
      d2end: moment(d2end).format("YYYY-MM-DD")
    });
  };

  // utils
  const isActionDisabled = () => {
    return action === "" || actionLoading || checked.length == 0;
  };

  let allChecked = true;
  stat.stat.forEach(item => {
    if (!checked.includes(item.tid)) {
      allChecked = false;
    }
  });

  // effects

  const load = () => {
    setLoading(true);
    NewsStatService(search)
      .then(data => {
        setStat(data);
        setLoading(false);
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    load();
  }, [search]);

  return (
    <div className="page-news">
      <FixedHeader>
        <PrimaryHeader className="page-news__header">
          <span className="header__title">Новости</span>
          <div className="page-news__header-controls">
            <Select
              placeholder="Выбор кампании"
              theme="dark"
              className="campaign"
              searchable={true}
              options={globalsContext.campaigns_for_news}
              value={parseInt(search.cid)}
              onSelect={onCampaignSelect}
            />
            <Select
              placeholder="Статус"
              theme="dark"
              className="status"
              value={parseInt(search.status)}
              options={statusOptions}
              onSelect={onStatusSelect}
            />
          </div>
        </PrimaryHeader>
      </FixedHeader>
      <div className="content-body content-body__with-fixed">
        <div className="page-news__controls">
          <Select
            placeholder="Действие"
            className="page-news__action"
            options={actionOptions}
            onSelect={onActionSelect}
            value={action}
          />
          <Button
            color="blue"
            disabled={isActionDisabled()}
            onClick={applyAction}
          >
            Выполнить
          </Button>
          <div className="page-news__date-range">
            <DateRange
              className="left"
              startDate={moment(search.d1start)}
              endDate={moment(search.d1end)}
              onChange={onD1Change}
            />
            <DateRange
              className="left"
              startDate={moment(search.d2start)}
              endDate={moment(search.d2end)}
              onChange={onD2Change}
            />
          </div>
        </div>

        <NewsTable
          onCheck={onCheck}
          onGlobalCheck={onGlobalCheck}
          stat={stat.stat}
          summary={stat.summary}
          checked={checked}
          allChecked={allChecked}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default News;
